import React from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { cls } from 'js/utils/classNameBuilder.util';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import style from './index.scss';

export default ({
    count,
    activeSlide,
    showNumbers,
    position = {},
    classNames = {},
    onClick = () => {},
    isBulletsClickable = true
}) => {
    const { x, y, offsetX, offsetY } = position;
    const translate = useTranslations('playtech.mobile.system.slider.');

    const inlineStyle = {
        textAlign: x || 'center',
        verticalAlign: y || 'bottom',
        [x === 'right' ? 'right' : 'left']: offsetX || 0,
        [y]: offsetY || 0
    };
    const buildCls = cls([style, classNames]);
    const getClass = item => buildCls([
        showNumbers && 'button' || 'bullet',
        activeSlide === item && 'active' || '' // do not remove empty string (jest.config:18)
    ]);

    return (
        <ul className={buildCls(['bullets'])} style={inlineStyle}>
            {Array.from(new Array(count).keys()).map(item =>
                <AccessibilityElement
                    key={item}
                    tagName="li"
                    className={getClass(item)}
                    tabIndex={isBulletsClickable ? 0 : -1}
                    {...isBulletsClickable && { onClick: () => onClick(item) }}
                    aria-label={`${translate('aria-label.bullet')} ${item + 1}`}
                >
                    {showNumbers ? item + 1 : ''}
                </AccessibilityElement>
            )}
        </ul>
    );
};
